import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingScheduledUpcomingPaymentsAPI = async (params: {
  startDate: string;
  endDate: string;
  format?: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/scheduled-upcoming-payments',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingScheduledUpcomingPayments = (params: {
  startDate: string;
  endDate: string;
  format?: string;
}) => {
  return useQuery({
    queryKey: [KEYS.SCHEDULED_UPCOMING_PAYMENTS, params],
    queryFn: () => reportingScheduledUpcomingPaymentsAPI(params),
    enabled: !!params.startDate && !!params.endDate && !!params.format,
  });
};
